import moment from 'moment'
import 'moment-timezone'

export function initial() {
  let lang = checkLanguage('lang') || 'lv_LV'
  let country = checkLanguage('country') || 'LV'
  let customerType = checkLanguage('customerType')
  let meetingType = checkLanguage('meetingType')

  loadMomentLocale(lang)
  return { lang, country, customerType, meetingType }
}

export function setMomentLocale(lang) {
  loadMomentLocale(lang)
}

function checkLanguage(variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].replace('/', '').split('=')

    if (variable == 'country') {
      if (pair[0] == 'country') {
        switch (pair[1].toUpperCase()) {
          case 'EE':
            return 'EE'
          case 'LT':
            return 'LT'
          default:
            return 'LV'
        }
      }
    } else if (variable == 'lang') {
      if (pair[0] == 'lang') {
        switch (pair[1]) {
          case 'ru_RU':
            return 'ru_RU'
          case 'en_US':
            return 'en_US'
          case 'lt_LT':
            return 'lt_LT'
          case 'et_EE':
            return 'et_EE'
          case 'tt_RU':
            return 'tt_RU'
          default:
            return 'lv_LV'
        }
      } else if (pair[0] == 'locale') {
        switch (pair[1].toLowerCase()) {
          case 'ru':
            return 'ru_RU'
          case 'en':
            return 'en_US'
          case 'lt':
            return 'lt_LT'
          case 'ee':
            return 'et_EE'
          case 'tt':
            return 'tt_RU'
          default:
            return 'lv_LV'
        }
      }
    } else if (variable == 'customerType') {
      if (pair[0] == 'customerType') {
        switch (pair[1].toUpperCase()) {
          case 'FP':
            return 'FP'
          case 'JP':
            return 'JP'
          default:
            return 'JP'
        }
      }
    } else if (variable == 'meetingType') {
      if (pair[0] == 'meetingType') {
        return pair[1]
      }
    }
  }
}

function loadMomentLocale(lang) {
  switch (lang) {
    case 'lt_LT':
      moment.updateLocale('lt', {
        longDateFormat: {
          L: 'YYYY.MM.DD HH:mm',
        },
      })
      return 'lt'
    case 'ru_RU':
      moment.updateLocale('ru', {
        longDateFormat: {
          L: 'DD.MM.YYYY HH:mm',
        },
      })
      return 'ru'
    case 'en_US':
      moment.updateLocale('en', {
        longDateFormat: {
          L: 'DD.MM.YYYY HH:mm',
        },
      })
      return 'en'
    case 'et_EE':
      moment.updateLocale('et', {
        longDateFormat: {
          L: 'DD.MM.YYYY HH:mm',
        },
      })
      return 'et'
    default:
      moment.updateLocale('lv', {
        longDateFormat: {
          L: 'DD.MM.YYYY HH:mm',
        },
      })
      return 'lv'
  }
}

export function setTimeZone(date, country) {
  let momentDate = moment.unix(date)
  let timezone = ''

  switch (country) {
    case 'LT':
      timezone = 'Europe/Vilnius'
      break
    case 'EE':
      timezone = 'Europe/Tallinn'
      break
    default:
      timezone = 'Europe/Riga'
      break
  }
  return momentDate.tz(timezone).format('L')
}

export function getCountryURL(country, lang, type) {
  return countryURL[type][country][lang]
}

const countryURL = {
  JP: {
    EE: {
      et_EE: 'https://www.seb.ee/sites/default/files/web/files/tingimused/SEB_uldtingimused_EST_2019.pdf',
      en_US: 'https://www.seb.ee/files/tingimused/as_seb_pank_yldtingimused_01012020_eng.pdf',
      tt_RU: 'https://www.seb.ee/files/tingimused/as_seb_pank_yldtingimused_01012020_rus.pdf ',
    },
  },
  FP: {
    LV: {
      lv_LV: 'https://www.seb.lv/vecakiem',
      en_US: 'https://www.seb.lv/eng/loyalty-programs/parents',
      ru_RU: 'https://www.seb.lv/ru/vecakiem',
    },
    EE: {
      et_EE: 'https://www.seb.ee/lapsed',
      tt_RU: 'https://www.seb.ee/ru/deti',
      en_US: 'https://www.seb.ee/eng/children',
    },
  },
  terms: {
    EE: {
      et_EE: 'https://www.seb.ee/sites/default/files/tac/SEB_isikuandmete_tootlemise_tingimused_est.pdf',
      en_US: 'https://www.seb.ee/sites/default/files/tac/SEB_isikuandmete_tootlemise_tingimused_eng.pdf',
      tt_RU: 'https://www.seb.ee/sites/default/files/tac/SEB_isikuandmete_tootlemise_tingimused_rus.pdf',
    },
    LV: {
      lv_LV: 'https://www.seb.lv/sites/default/files/web/files/prod_doc/DAN_LV.pdf',
      ru_RU: 'https://www.seb.lv/sites/default/files/web/files/prod_doc/DAN_LV.pdf',
      en_US: 'https://www.seb.lv/sites/default/files/web/files/prod_doc/DAN_LV.pdf',
    },
    LT: {
      en_US: 'https://www.seb.lt/sites/default/files/web/pdf/Privatumo_politika_EN.pdf',
      lt_LT: 'https://www.seb.lt/sites/default/files/web/pdf/LT_Privatumo_politika.pdf',
      ru_RU: 'https://www.seb.lt/sites/default/files/web/pdf/LT_Privatumo_politika.pdf',
    },
  },
  videoPrepare: {
    EE: {
      et_EE: 'https://www.seb.ee/eraklient/igapaevapangandus/abivahendid-ja-internetiteenused/videokohtumine',
      en_US: 'https://www.seb.ee/en/private/daily-banking/tools-and-online-services/video-meeting',
      tt_RU: 'https://www.seb.ee/ru/chastnyy-klient/povsednevnye-uslugi/instrumenty-i-onlayn-uslugi/video-meeting',
    },
    LV: {
      lv_LV: 'https://www.seb.lv/privatpersonam/ikdienas-pakalpojumi/riki-un-tiessaistes-pakalpojumi/video-meeting',
      ru_RU: 'https://www.seb.lv/ru/chastnym-licam/povsednevnye-uslugi/instrumenty-i-onlayn-uslugi/video-meeting',
      en_US: 'https://www.seb.lv/en/private/daily-banking/tools-and-online-services/video-meeting',
    },
    LT: {
      en_US: 'https://www.seb.lt/en/business/daily-banking/online-services/video-consultation-business',
      lt_LT:
        'https://www.seb.lt/verslui/kasdiene-bankininkyste/paslaugos-internetu/vaizdo-konsultacija-verslo-klientams',
    },
  },
  default: {
    all: {
      terms: 'https://www.seb.lv/sites/default/files/web/files/prod_doc/DAN_LV.pdf',
    },
  },
}

const inputOrderTypes = {
  service_first: [
    { component: 'ServiceSelect', first: true, id: 'appointmentGroupId' },
    { component: 'BranchSelect', first: false, waitFor: 'appointmentGroupId', id: 'branchTypeId' },
  ],
  branch_first: [
    { component: 'BranchSelect', first: true, id: 'branchTypeId' },
    { component: 'ServiceSelect', first: false, waitFor: 'branchTypeId', id: 'appointmentId' },
  ],
}

export function getCountryInputOrder(type) {
  if (!type) return
  return inputOrderTypes[type]
}

export function getLocaleOptions(country) {
  let lv = [
    { name: 'Latvian', value: 'lv' },
    { name: 'Russian', value: 'ru' },
    { name: 'English', value: 'en' },
  ]
  let et = [
    { name: 'Estonian', value: 'et' },
    { name: 'Russian', value: 'ru' },
    { name: 'English', value: 'en' },
  ]
  let lt = [
    { name: 'Lithuanian', value: 'lt' },
    { name: 'Russian', value: 'ru' },
    { name: 'English', value: 'en' },
  ]
  switch (country) {
    case 'LV':
      return lv
    case 'LT':
      return lt
    case 'EE':
      return et
    default:
  }
}
